(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('multiSort', multiSort);

    function multiSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicates: '=multiSort',
                callback: '&'
            },
            controller: MultiSortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    MultiSortController.$inject = ['$scope', '$element'];

    function MultiSortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watch('vm.predicates', vm.triggerApply, true);
        vm.triggerApply();

        function applyClass (element, sortField) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = '',
                add = '';
            if(vm.predicates[sortField] == null){
                remove = sortAsc + ' ' + sortDesc;
                add = sortIcon;
                delete vm.predicates[sortField];
            }else if (!vm.predicates[sortField]) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            } else if(vm.predicates[sortField]) {
                remove = sortIcon + ' ' + sortDesc;
                add = sortAsc;
            }
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {

            if( vm.predicates && vm.predicates[field] != null){
                if(vm.predicates[field]) {
                    vm.predicates[field] = ! vm.predicates[field];
                } else{
                    vm.predicates[field] = null;
                }
            } else {
                vm.predicates[field] = true;
            }
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            var keys = Object.keys(vm.predicates);
            if (keys.length > 0 && values && values[0] !== '_score') {
                for(var key in keys) {
                    vm.applyClass($element.find('th[multi-sort-by=\'' + keys[key] + '\']'), keys[key]);
                }
            }
        }
    }
})();
